/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionGroundedComponent = function (unit, state) {
    Merge2MissionUnitComponent.call(this, unit);
    this.state = state !== undefined ? state : Merge2MissionGroundedComponent.STATE.FOG;
};

Merge2MissionGroundedComponent.prototype = Object.create(Merge2MissionUnitComponent.prototype);
Merge2MissionGroundedComponent.prototype.constructor = Merge2MissionGroundedComponent;

Merge2MissionGroundedComponent.STATE = {
    FOG: 0,
    GROUNDED: 1
};

Merge2MissionGroundedComponent.prototype.isMovable = function () {
    return false;
};

Merge2MissionGroundedComponent.prototype.isMergeable = function () {
    return this.isOpened();
};

Merge2MissionGroundedComponent.prototype.isOpened = function () {
    return this.state === Merge2MissionGroundedComponent.STATE.GROUNDED;
};

Merge2MissionGroundedComponent.prototype.isFog = function () {
    return this.state === Merge2MissionGroundedComponent.STATE.FOG;
};

Merge2MissionGroundedComponent.prototype.updateState = function (field) {
    if (this.isOpened()) {
        return false;
    }

    const isOpen = field.getNeighbours(this.unit.x, this.unit.y).some((cell) => {
        const neighbour = field.getUnit(cell.x, cell.y);
        return !neighbour || !neighbour.findComponent(Merge2MissionGroundedComponent);
    });

    if (!isOpen) {
        return false;
    }

    this.state = Merge2MissionGroundedComponent.STATE.GROUNDED;

    return true;
};
